import * as React from 'react';
const SvgCsvFailed = (props) => (
  <svg
    width={131}
    height={148}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M122.647 69.5466C122.647 83.7466 116.847 96.5466 107.547 105.747C98.4468 114.847 85.8468 120.347 71.9468 120.347C58.1468 120.347 45.5468 114.747 36.3468 105.747C27.0468 96.5466 21.2468 83.7466 21.2468 69.5466C21.2468 41.4466 43.9468 18.7466 71.9468 18.7466C99.9468 18.7466 122.647 41.5466 122.647 69.5466Z"
      fill="#EAEEF9"
    />
    <path
      d="M118.247 36.2464C120.511 36.2464 122.347 34.4108 122.347 32.1464C122.347 29.882 120.511 28.0464 118.247 28.0464C115.982 28.0464 114.147 29.882 114.147 32.1464C114.147 34.4108 115.982 36.2464 118.247 36.2464Z"
      fill="#EAEEF9"
    />
    <path
      d="M124.247 20.2465C125.793 20.2465 127.047 18.9929 127.047 17.4465C127.047 15.9001 125.793 14.6465 124.247 14.6465C122.7 14.6465 121.447 15.9001 121.447 17.4465C121.447 18.9929 122.7 20.2465 124.247 20.2465Z"
      fill="#EAEEF9"
    />
    <path
      d="M22.8469 36.1464C24.3933 36.1464 25.6469 34.8928 25.6469 33.3464C25.6469 31.8 24.3933 30.5464 22.8469 30.5464C21.3005 30.5464 20.0469 31.8 20.0469 33.3464C20.0469 34.8928 21.3005 36.1464 22.8469 36.1464Z"
      fill="#EAEEF9"
    />
    <path
      d="M5.74687 90.1466C8.61876 90.1466 10.9469 87.8185 10.9469 84.9466C10.9469 82.0747 8.61876 79.7466 5.74687 79.7466C2.87499 79.7466 0.546875 82.0747 0.546875 84.9466C0.546875 87.8185 2.87499 90.1466 5.74687 90.1466Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d)">
      <path
        d="M108.076 46.2575L108.876 110.658C108.876 112.858 107.076 114.558 104.876 114.558H42.0762C39.8762 114.558 38.0762 112.758 38.0762 110.658V27.8575C38.0762 25.6575 39.8762 23.9575 42.0762 23.9575H87.5762L108.076 46.2575Z"
        fill="url(#paint0_linear)"
      />
    </g>
    <path
      d="M70.7761 37.4574H48.6761C47.9761 37.4574 47.3761 36.8574 47.3761 36.1574C47.3761 35.4574 47.9761 34.8574 48.6761 34.8574H70.7761C71.4761 34.8574 72.0761 35.4574 72.0761 36.1574C72.0761 36.8574 71.4761 37.4574 70.7761 37.4574Z"
      fill="#D5DDEA"
    />
    <path
      d="M60.2761 44.6576H48.6761C47.9761 44.6576 47.3761 44.0576 47.3761 43.3576C47.3761 42.6576 47.9761 42.0576 48.6761 42.0576H60.1761C60.8761 42.0576 61.4761 42.6576 61.4761 43.3576C61.4761 44.0576 60.8761 44.6576 60.2761 44.6576Z"
      fill="#D5DDEA"
    />
    <path
      d="M87.5762 23.9575V41.7575C87.5762 44.2575 89.7762 46.2575 92.2762 46.2575H108.076"
      fill="#D5DDEA"
    />
    <path
      d="M57.3094 37.2227L62.061 20.4627L81.5776 22.7107L74.7637 33.6331L80.0415 37.8498L68.6787 62.7035L69.3118 43.4619L57.3094 37.2227Z"
      fill="#EAEEF9"
    />
    <path
      d="M61.5269 18.0123L57.7452 12.3198"
      stroke="#A2ABBE"
      strokeWidth={2}
    />
    <path
      d="M71.6119 15.1661L72.0562 0.746582"
      stroke="#A2ABBE"
      strokeWidth={2}
    />
    <path
      d="M80.6538 18.1466L86.6904 5.04395"
      stroke="#A2ABBE"
      strokeWidth={2}
    />
    <path
      d="M60.1181 90.1257C59.698 90.1257 59.362 89.9576 59.0259 89.7056C58.4378 89.1175 58.4378 88.1094 59.0259 87.5213C62.8905 83.7407 68.0153 81.6404 73.4761 81.6404C78.9369 81.6404 84.0617 83.7407 87.9263 87.5213C88.5144 88.1094 88.5144 89.1175 87.9263 89.7056C87.3382 90.2937 86.3301 90.2937 85.742 89.7056C82.4655 86.4291 78.0968 84.6648 73.4761 84.6648C68.8554 84.6648 64.4867 86.4291 61.2102 89.7056C60.8742 89.9576 60.5381 90.1257 60.1181 90.1257Z"
      fill="#989FB0"
    />
    <path
      d="M65.4109 67.6102L67.4272 65.5939C68.0153 65.0058 68.0153 63.9977 67.4272 63.4096C66.8391 62.8215 65.8309 62.8215 65.2429 63.4096L63.2265 65.4259L61.2102 63.4096C60.6221 62.8215 59.614 62.8215 59.0259 63.4096C58.4378 63.9977 58.4378 65.0058 59.0259 65.5939L61.0422 67.6102L59.0259 69.6265C58.4378 70.2146 58.4378 71.2228 59.0259 71.8108C59.362 72.1469 59.698 72.2309 60.1181 72.2309C60.5381 72.2309 60.8742 72.0629 61.2102 71.8108L63.2265 69.7945L65.2429 71.8108C65.5789 72.1469 65.915 72.2309 66.335 72.2309C66.7551 72.2309 67.0911 72.0629 67.4272 71.8108C68.0153 71.2228 68.0153 70.2146 67.4272 69.6265L65.4109 67.6102Z"
      fill="#989FB0"
    />
    <path
      d="M85.826 67.6102L87.8423 65.5939C88.4304 65.0058 88.4304 63.9977 87.8423 63.4096C87.2543 62.8215 86.2461 62.8215 85.658 63.4096L83.6417 65.4259L81.6254 63.4096C81.0373 62.8215 80.0292 62.8215 79.4411 63.4096C78.853 63.9977 78.853 65.0058 79.4411 65.5939L81.4574 67.6102L79.4411 69.6265C78.853 70.2146 78.853 71.2228 79.4411 71.8108C79.7771 72.1469 80.1132 72.2309 80.5332 72.2309C80.9533 72.2309 81.2893 72.0629 81.6254 71.8108L83.6417 69.7945L85.658 71.8108C85.9941 72.1469 86.3301 72.2309 86.7502 72.2309C87.1702 72.2309 87.5063 72.0629 87.8423 71.8108C88.4304 71.2228 88.4304 70.2146 87.8423 69.6265L85.826 67.6102Z"
      fill="#989FB0"
    />
    <defs>
      <filter
        id="filter0_d"
        x={16.0762}
        y={12.9575}
        width={114.8}
        height={134.6}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1={73.4531}
        y1={21.8619}
        x2={73.4531}
        y2={115.534}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgCsvFailed;
